import { all, takeLatest } from "redux-saga/effects";
import { types as modalsAnchorActions } from "@/bit/reducers/reducers.modals-reducer";
import { types as mainActions } from "@/bit/reducers/reducers.main-reducer";
import { types as formActions } from "@/reducers/form-reducer";
import { types as retargetingActions } from "@/reducers/retargeting";

import {
  initAnchorModalListener,
  addModal,
} from "@/bit/sagas/sagas.modals-saga";
import {
  checkCPAndSetZones,
  setReadNotificationsSaga,
} from "@/bit/sagas/sagas.main-saga";
import { sendDraw } from "@/sagas/form-saga";
import { sendRetargetingSaga } from "@/sagas/retargeting";

function* rootSaga() {
  yield all([
    takeLatest(
      modalsAnchorActions.INIT_ANCHOR_MODAL_LISTENER,
      initAnchorModalListener
    ),
    takeLatest(modalsAnchorActions.ADD_MODAL, addModal),
    //cp
    takeLatest(mainActions.CHECK_CP_AND_SET_ZONES, checkCPAndSetZones),
    // notifications

    takeLatest(
      mainActions.SET_READ_NOTIFICATIONS_INIT,
      setReadNotificationsSaga
    ),
    takeLatest(formActions.SEND_DRAW_REQUEST, sendDraw),
    takeLatest(retargetingActions.SEND_RETARGETING, sendRetargetingSaga),
  ]);
}

export default rootSaga;
